import classNames from "classnames"
import { BorderColor, BorderShape } from "components/DesignSystem"

import { determineBorderColorClass } from "./determineBorderColorClass"
import { determineBorderShapeClass } from "./determineBorderShapeClass"

/**
 *  A class that determines the border class based on the passed border color
 *  and shape. This function also adds the base "border" class to the returned
 *  value.
 */
export function determineBorderClass(
  borderColor: BorderColor = "border/default",
  borderShape: BorderShape = "border/shape/6"
) {
  return classNames("border", determineBorderColorClass(borderColor), determineBorderShapeClass(borderShape))
}
